<template>
  <div id="footer" :class="{'mobile': isMobileDevice()}">
    <div class="serive">
      <div class="container">
        <div class="list">
          <div class="item">
            <img src="@/assets/img/footer-1.png"></img>
            <div class="text">
              <div class="title">7x24小时售后支持</div>
              <div class="decs">全国7×24小时客服热线</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/footer-2.png"></img>
            <div class="text">
              <div class="title">性能安全</div>
              <div class="decs">30,000+ 每秒访问处理经验</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/footer-3.png"></img>
            <div class="text">
              <div class="title">增值服务</div>
              <div class="decs">自助发卡系统，自主设计/渠道推广</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/footer-4.png"></img>
            <div class="text">
              <div class="title">多对一团队服务</div>
              <div class="decs">商务运营团队多对一提供服务</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy">
      <div class="kefu">
        <img src="@/assets/img/kefu-phone.png"></img>
        <div class="kefu-info">
          <div class="title">客服咨询</div>
          <div class="decs">400-106-9088</div>
          <div class="time">工作时间：上午9:00-下午18:00</div>
        </div>
      </div>
      <div class="container">
        <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2023018600号-3</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.serive .list {
  display: flex;
  flex-wrap: wrap;
}
.serive .list .item{
  margin: 60px 20px;
  display: flex;
  align-items: center;
}
.serive .list .item .text{
  margin-left: 10px;
}
.serive .list .item .title{
  font-size: 18px;
}
.serive .list .item .decs{
  color: #9c9c9c;
  font-size: 14px;
  margin-top:10px;
}
.serive {
  color: #fff;
  background: #1D1D1D;
}
.mobile .serive .list .item{
  margin: 20px;
}
.copy .kefu {
  display: flex;
  justify-content: center;
}
.copy .kefu img{
  width: 66px;
  height: 66px;
}
.copy .kefu .kefu-info {
  margin-left: 30px;
  color: rgb(157, 157, 157);
}
.copy .kefu .kefu-info .title{
  font-size: 18px;
}
.copy .kefu .kefu-info .decs{
  font-size: 30px;
}
.copy .kefu .kefu-info .time{
  font-size: 14px;
}
.copy .container{
  width: 100%;
  margin: 20px 0;
  text-align: center;
}
.copy {
  background: #24262a;
  padding: 30px 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue